<div>
  <!-- Tabs -->
  <tab-selector
    [tabs]="tabs"
    [activeTab]="activeTab"
    (tabClick)="_handleTabClick($event)"
  ></tab-selector>
  <div
    class="p-15px fs-15px"
    *ngIf="!loading && activeTab === AdminNodeFeesComponent.FEES"
  >
    <button
      (click)="addNewFee('ALL')"
      class="btn btn-outline-primary fs-15px"
      [disabled]="removingFee"
    >
      Add Fee Recipient To All Transactions
    </button>
    <div
      *ngFor="
        let transactionFee of transactionFeeMap | keyvalue;
        let ii = index
      "
      class="py-15px"
    >
      <div class="d-flex justify-content-between">
        <span>{{ transactionFee.key }}</span>
        <i
          class="fas fa-plus text-success"
          (click)="addNewFee(transactionFee.key)"
        ></i>
      </div>
      <div *ngFor="let item of transactionFee.value" class="d-flex flex-column">
        <div class="d-flex flex-start align-items-center">
          <i
            class="fas fa-trash text-danger pr-5px fs-18px"
            (click)="removeFee(transactionFee.key, item.PublicKeyBase58Check)"
          ></i>
          <simple-profile-card
            [profile]="
              item.ProfileEntryResponse || {
                PublicKeyBase58Check: item.PublicKeyBase58Check
              }
            "
            [hideFollowLink]="true"
            [singleColumn]="true"
          ></simple-profile-card>
          <span> {{ globalVars.nanosToDeSo(item.AmountNanos) }} $DESO </span>
        </div>
      </div>
    </div>
  </div>
  <div
    class="p-15px fs-15px"
    *ngIf="!loading && activeTab === AdminNodeFeesComponent.EXEMPT_KEYS"
  >
    <search-bar
      [showCloutavista]="false"
      [isSearchForUsersToSendDESO]="true"
      (creatorToMessage)="selectedCreator = $event"
    ></search-bar>
    <simple-profile-card
      [profile]="selectedCreator"
      [hideFollowLink]="true"
      [singleColumn]="true"
      *ngIf="selectedCreator"
    ></simple-profile-card>
    <button
      (click)="addExemptKey()"
      class="btn btn-outline-primary fs-15px"
      [disabled]="addingExemptKey || !selectedCreator?.PublicKeyBase58Check"
    >
      Exempt From Fees
    </button>
    <div class="py-15px">
      <div class="py-15px">Users exempt from fees:</div>
      <div
        *ngFor="let exemptKey of exemptPublicKeyMap | keyvalue"
        class="d-flex flex-start pr-5px align-items-center fs-18px"
      >
        <i
          class="fas fa-trash text-danger"
          (click)="removeExemptKey(exemptKey.key)"
        ></i>
        <simple-profile-card
          [profile]="exemptKey.value || { PublicKeyBase58Check: exemptKey.key }"
          [hideFollowLink]="true"
          [singleColumn]="true"
        ></simple-profile-card>
      </div>
    </div>
  </div>
  <div>
    <simple-center-loader *ngIf="loading"></simple-center-loader>
  </div>
</div>
